import {
  SR_API_ACTION_HOUSEHOLD_GET_APPLICATION_SUBMISSIONS,
} from 'api/actionTypes';

export default async function loadApplicationSubmissions({ state, apiClient }, { userId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_APPLICATION_SUBMISSIONS,
    state: state,
    payload: {
      userId,
    },
    onSuccess(householdApplicationSubmissions) {
      state.set(['householdApplicationSubmissions'], householdApplicationSubmissions);
      return householdApplicationSubmissions;
    },
  });
}
